import classNames from "classnames";
import React from "react";
import { intl } from "../../../i18n/TypedIntl";
import styles from "./levelTextIndicator.css";

export enum Level {
  Low,
  Mid,
  High
}

interface Props {
  level: Level;
}

export const LevelIndicator = ({ level }: Props) => {
  const renderLevelText = () => {
    switch (level) {
      case Level.Low:
        return intl.formatMessage("level.low");
      case Level.Mid:
        return intl.formatMessage("level.mid");
      case Level.High:
        return intl.formatMessage("level.high");
      default:
        return;
    }
  };

  return (
    <p
      className={classNames(styles.text, {
        [styles.low]: level === Level.Low,
        [styles.medium]: level === Level.Mid,
        [styles.high]: level === Level.High
      })}
    >
      {renderLevelText()}
    </p>
  );
};
